import { List } from 'immutable';
import { editorStateToString } from 'features/wells/overview/activityLog/helpers/activityLog.constants';

const upsertActivityLogDTO = ({ ...activity }, activityLogId) => {
  return {
    activityLogId: activityLogId,
    activityName: activity.activityName,
    description: activity.description
      ? editorStateToString(activity.description)
      : null,
    status: activity.status,
    startDate: activity.startDate,
    endDate: activity.endDate,
    comment: activity.comment ? editorStateToString(activity.comment) : null,
    mitigationSolutions: activity.mitigationSolutions
      ? editorStateToString(activity.mitigationSolutions)
      : null,
    responsibleId: activity.responsibleId,
  };
};

const fromActivityLogDTO = (activities) => {
  return List({ ...activities });
};

const activityLogMappers = {
  activities: {
    upsert: upsertActivityLogDTO,
    from: fromActivityLogDTO,
  },
};

export default activityLogMappers;
